import { __assign, __extends } from "tslib";
import { Plot } from '../../core/plot';
import { DEFAULT_TOOLTIP_OPTIONS } from '../tiny-line/constants';
import { adaptor } from './adaptor';
var TinyArea = /** @class */ (function (_super) {
    __extends(TinyArea, _super);
    function TinyArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 图表类型 */
        _this.type = 'tiny-area';
        return _this;
    }
    TinyArea.prototype.getDefaultOptions = function (options) {
        return {
            appendPadding: 2,
            tooltip: __assign({}, DEFAULT_TOOLTIP_OPTIONS),
            // 默认样式
            color: 'l(90) 0:#5B8FF9 1:#ffffff',
            areaStyle: {
                fillOpacity: 0.6,
            },
            line: {
                size: 1,
                style: {
                    stroke: '#5B8FF9',
                },
            },
        };
    };
    /**
     * 获取 迷你面积图 的适配器
     */
    TinyArea.prototype.getSchemaAdaptor = function () {
        return adaptor;
    };
    return TinyArea;
}(Plot));
export { TinyArea };
//# sourceMappingURL=index.js.map